import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import ClientPopUp from "./client_popup.js";
import MultiSelectNew from "./multiSelect.js";
import AddClient from "./addClient_popup.js";
import { MultiSelect } from "react-multi-select-component";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const AcceptLeads = (props) => {
  const [clients, setClients] = useState([]);
  const [clientsReportValue, setClientsReportValue] = useState([]);
  const [showClientReport, setShowClientReport] = useState(false);
  const [showAddClient, setShowAddClient] = useState(false);
  const [leadId, setLeadId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lawyersData, setLawyersData] = useState([]);
  const [courtsData, setCourtsData] = useState([]);
  const [banksData, setBanksData] = useState([]);
  const [editOption, setEditOption] = useState("all");

  const closeAddClient = () => {
    setShowAddClient(false);
    getData();
  };

  const checkEditOption = (option) => {
    if (editOption === "all") {
      return true;
    } else if (option === editOption) {
      return true;
    } else {
      return false;
    }
  };

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsArchive", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClients(
          data.filter(
            (el) =>
              props.user.teamFinish.includes(el.finishTeam) &&
              el.finishTeam !== "" &&
              el.finalized !== "1"
          )
        );
        fetchLawyers();
      })
      .catch((error) => {});
  };

  const fetchLawyers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawyersData(data);
        fetchCourts();
      })
      .catch((error) => {});
  };

  const fetchCourts = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCourtsData(data);
        fetchBanks();
      })
      .catch((error) => {});
  };

  const fetchBanks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanksData(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const showAddClientF = (e) => {
    setShowAddClient(true);
    setLeadId(e.target.value);
  };

  const pushBack = async (e) => {
    var body = {
      leadId: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/pushBackLeadCase", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Cofnięto",
          text: "zlecenie założenia sprawy",
        }).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const clientsData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>Imię i nazwisko</th>
          <th>Załóż sprawę</th>
        </tr>
        {clients.map((el) => (
          <>
            <tr id={""} key={el.id}>
              <td
                style={{
                  fontWeight: "600",
                  maxWidth: "80%",
                  width: "80%",
                  wordBreak: "break-word",
                }}
                value={el.id}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    gap: "10px",
                    position: "relative",
                  }}
                >
                  <div style={{ paddingRight: "30px", paddingLeft: "5px" }}>
                    {el.name}
                  </div>
                </div>
              </td>
              <td
                value={el.id}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <button
                  className="viewButton"
                  value={el.id}
                  onClick={showAddClientF}
                >
                  PRZEJDŹ
                </button>
                {props.user.cofnijZlecSpraweFinish === "1" ? (
                  <>
                    <button
                      className="viewButton"
                      value={el.id}
                      onClick={pushBack}
                    >
                      COFNIJ
                    </button>
                  </>
                ) : (
                  ""
                )}
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          {showAddClient ? (
            <AddClient
              lawyersData={lawyersData}
              courtsData={courtsData}
              banksData={banksData}
              close={closeAddClient}
              refreshData={props.refreshData}
              logClientAction={props.logClientAction}
              paymentsSheetData={props.paymentsSheetData}
              users={props.users}
              mode={"lead"}
              editOption={editOption}
              checkEditOption={checkEditOption}
              userRole={props.user.role}
              userMail={props.user.mail}
              userPhone={props.user.Phone}
              team={0}
              user={props.user}
              userD={props.user}
              lead={clients.filter((el) => +el.id === +leadId)[0]}
            />
          ) : (
            ""
          )}
          {!showAddClient ? (
            <>
              <div id="reportC" className="mainContainerClients">
                <div className="closeBox">
                  <button className="closeClientButton" onClick={props.close}>
                    X
                  </button>
                </div>

                <>
                  <p style={{ fontWeight: "600", fontSize: "1.5vw" }}>
                    SPRAWY DO ZAŁOŻENIA ({clients.length} rekordów)
                  </p>
                  <span className="noteModuleP">
                    kliknij w rekord, aby zobaczyć szczegóły
                  </span>
                  <div className="contentBoxPayments">{clientsData}</div>
                </>
              </div>{" "}
            </>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default AcceptLeads;
